/**
 * Impact requires the email to arrive already hashed - they hash again on
 * receipt, but rely on the brand for the initial pass. Returns null rather
 * than throwing: a missing hash costs one partner's email match, which is
 * never worth failing an identify call over.
 */
const hashEmail = async (email: string): Promise<string | null> => {
  const normalizedEmail = email.trim().toLowerCase()

  if (!normalizedEmail) {
    return null
  }

  try {
    const digest = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(normalizedEmail))

    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('')
  } catch {
    return null
  }
}

export default hashEmail
